import {Button, Container, Grid, Paper} from '@material-ui/core';
import EmulationNoAccess from 'AgencyAdministration/components/EmulationNoAccess';
import 'Core/components/NotAuthorized.sass';
import * as A from 'fp-ts/lib/Array';
import * as O from 'fp-ts/lib/Option';
import {pipe} from 'fp-ts/lib/pipeable';
import React from 'react';
import {Link} from 'react-router-dom';
import {UserClaims, UserTypeClaimKey, UserTypeClaims} from 'Users/models/Claims';

type NotAuthorizedProps = {
  claims: UserClaims;
};

const NotAuthorized = ({claims}: NotAuthorizedProps) => {
  const originalUserName = pipe(
    claims.userTypes,
    A.map(
      UserTypeClaims.match({
        [UserTypeClaimKey.AgentSite]: agentClaims =>
          agentClaims.impersonatedAgentClaim ? O.some(claims.userName) : O.none,
        default: () => O.none,
      })
    ),
    A.filter(O.isSome),
    A.head,
    O.flatten
  );

  return pipe(
    originalUserName,
    O.fold(
      () => (
        <Container maxWidth="lg" className="unauthorized">
          <Paper className="unauthorized__paper">
            <Grid container justify="center" direction="column">
              <Grid item>
                <h1 className="unauthorized__title">Access Denied</h1>
                <p className="unauthorized__description">You do not have access to this page.</p>
              </Grid>
              <Grid item>
                <p>
                  If you feel this is in error and need immediate assistance, please contact production support (866)
                  828-8074.
                </p>
              </Grid>
              <Grid item>
                <Grid container justify="flex-end">
                  <Link to="/">
                    <Button variant="contained" color="primary">
                      Return to Home
                    </Button>
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Container>
      ),
      originalUserName => <EmulationNoAccess originalUserName={originalUserName} />
    )
  );
};

export default NotAuthorized;
